// routes/DeepResearchRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import DeepResearchPage from '../components/Frontend/DeepResearchPage/DeepResearchPage';

export const deepResearchRoutes = (
    <Route path="/deep_research" element={<MainLayout />}>
        <Route index element={<DeepResearchPage />} />
    </Route>
);
